export default __webpack_public_path__ + "static/media/logo-itlo.0969a706.png";